import EmailOrPhoneFormValidationStrategy from "./validators/EmailOrPhoneFormValidationStrategy.js";
import PasswordFormValidationStrategy from "./validators/PasswordFormValidationStrategy.js";
import NameValidationStrategy from "./validators/NameValidationStrategy.js";
import EmailValidationStrategy from "./validators/EmailValidationStrategy.js";
import CompanyValidationStrategy from "./validators/CompanyValidationStrategy.js";
import PhoneValidationStrategy from "./validators/PhoneValidationStrategy.js";
import CheckboxValidationStrategy from "./validators/CheckboxValidationStrategy.js";
import CodeValidationStrategy from "./validators/CodeValidationStrategy.js";
import ConfirmPasswordValidationStrategy from "./validators/ConfirmPasswordValidationStrategy.js";

export default class ValidatorHandler {
  constructor() {
    const checkBoxClassHandler = new CheckboxValidationStrategy();
    this.strategyValidator = {
      emailOrPhone: new EmailOrPhoneFormValidationStrategy(),
      password: new PasswordFormValidationStrategy(),
      confirmPassword: new ConfirmPasswordValidationStrategy(),
      name: new NameValidationStrategy(),
      email: new EmailValidationStrategy(),
      company: new CompanyValidationStrategy(),
      phone: new PhoneValidationStrategy(),
      code: new CodeValidationStrategy(),
      personal: checkBoxClassHandler,
      offer: checkBoxClassHandler,
    };
  }

  getStrategyHandler(validatorType) {
    return this.strategyValidator[validatorType] || null;
  }

  validateField(field, form) {
    const validatorType = field.getAttribute("data-validation-handler"),
      isRequired = field.hasAttribute("data-require"),
      strategy = this.getStrategyHandler(validatorType);
    if (strategy) {
      if (field.type === "checkbox") {
        const checkboxValue = field.checked ? "1" : "0";
        return strategy.validate(checkboxValue, isRequired, form);
      } else {
        return strategy.validate(field.value, isRequired, form);
      }
    }

    return {
      isValid: true,
      message: "",
    };
  }

  removeClassesFromField(field, classes) {
    classes.forEach(c => {
      if (field.classList.contains(c)) {
        field.classList.remove(c);
      }
    });
  }

  addClassToField(field, className) {
    if (!field.classList.contains(className)) {
      field.classList.add(className);
    }
  }

  displayErrorMessages(message, field, show = true) {
    const attr = field.getAttribute("data-validation-handler"),
      errorBlock = field
        .closest("form")
        .querySelector(".error." + attr + "-error");

    if (errorBlock) {
      if (show) {
        errorBlock.textContent = message;

        if (!errorBlock.classList.contains("active")) {
          errorBlock.classList.add("active");
        }
      } else {
        errorBlock.textContent = "";
        if (errorBlock.classList.contains("active")) {
          errorBlock.classList.remove("active");
        }
      }
    }
  }

  updateSubmitButton(form, disabled = true) {
    const submitButton = form.querySelector('button[type="submit"]');

    if (disabled && !submitButton.classList.contains("disabled")) {
      submitButton.classList.add("disabled");
    }

    if (!disabled && submitButton.classList.contains("disabled")) {
      submitButton.classList.remove("disabled");
    }
  }

  isCheckbox(field) {
    return field.type === "checkbox";
  }

  validateCheckbox(field, res) {
    const id = field.getAttribute("id"),
      label = field.closest("form").querySelector(`[for="${id}"]`);

    if (!res.isValid) {
      if (!label.classList.contains("invalid")) {
        label.classList.add("invalid");
      }
    } else {
      if (label.classList.contains("invalid")) {
        label.classList.remove("invalid");
      }
    }
  }

  validateInput(field) {
    const form = field.closest("form");
    const res = this.validateField(field, form);

    if (this.isCheckbox(field)) {
      this.validateCheckbox(field, res);
    } else {
      const form = field.closest("form");
      this.removeClassesFromField(field, ["invalid", "valid"]);
      this.displayErrorMessages(null, field, false);
      if (!res.isValid) {
        this.addClassToField(field, "invalid");
        this.displayErrorMessages(res.message, field);
        this.updateSubmitButton(form);
      } else {
        this.addClassToField(field, "valid"); //добавила зеленый бордер при валидности
        this.updateSubmitButton(form, false);
      }
    }

    // Проверяем валидность всех полей формы после валидации текущего поля
    const formIsValid = this.checkFormValidity(form);
    this.updateSubmitButton(form, !formIsValid);
  }

  checkFormValidity(form) {
    const formFields = form.querySelectorAll("[data-validation-handler]");
    let allFieldsValid = true;

    formFields.forEach(field => {
      const res = this.validateField(field, form);
      if (!res.isValid) {
        allFieldsValid = false;
      }
    });

    return allFieldsValid;
  }

  validateForm(form) {
    const formFields = form.querySelectorAll("[data-validation-handler]");

    let formIsValid = true;

    formFields.forEach(field => {
      const res = this.validateField(field, form);

      if (this.isCheckbox(field)) {
        this.validateCheckbox(field, res);

        // Обработка невалидного чекбокса
        if (!res.isValid) {
          formIsValid = false; // Устанавливаем в false, если чекбокс невалиден
          this.addClassToField(field, "invalid");
        }
      } else {
        this.removeClassesFromField(field, ["invalid", "valid"]);
        this.displayErrorMessages(null, field, false);

        if (!res.isValid) {
          formIsValid = res.isValid;

          this.addClassToField(field, "invalid");
          this.displayErrorMessages(res.message, field);
          this.updateSubmitButton(form);
        } else {
          this.updateSubmitButton(form, false);
        }
      }
    });
    this.updateSubmitButton(form, !formIsValid);

    return formIsValid;
  }
}
